import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { UpgradeCompanyDto } from '../../types/company.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useUpgradePlan = () => {
  const { mutate: upgradePlan, isPending } = useAppMutation([QueryKey.CHANGE_PLAN], {
    mutationFn: ({ companyId, data }: { companyId: string; data: UpgradeCompanyDto }) =>
      ApiService.patch(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'upgrade'] },
        { body: data },
      ),
  });

  return {
    upgradePlan,
    isPending,
  };
};
